export const RESET_PASSWORD = 'reset-password';

export default function resetPassword({ email }) {
  return {
    type: RESET_PASSWORD,
    payload: { email },
  };
}
